// auth.service.ts
import { Injectable } from '@angular/core';
import { HttpClient,HttpParams, HttpResponse, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { LoginResponse } from '../models/user';
import { Router } from '@angular/router';
import * as jwt_decode from 'jwt-decode';
import * as actionSession from '../../core/actions/session.actions';
import { Store } from '@ngrx/store';
import { Contact } from '../models/contact';
import { environment } from './../../../environments/environment';
import { MessageService } from 'primeng/api';
import { BaseService } from './base.service';

@Injectable({
    providedIn: 'root',
})
export class ContactService extends BaseService {

  // Verify user credentials on server to get token
  getAll(sortField: string = 'name', sortOrder: number = 2, filters: any,
    first: number, rows: number): Observable<HttpResponse<any[]>> {

      let params = new HttpParams()
        .set('sort',((sortOrder===1) ? '' : '-') + sortField)
        .set('page', ((first/rows)+1).toString())
        .set('per-page', rows.toString());
          for (let a in filters) {
      params = params.set(a,filters[a].value);
    }  
    return this.http
      .get<any>(this.basePath + '/v1/contacts', {params: params,  observe: 'response'})
      .pipe(
        catchError(this.handleError)
      );
  }
  get(id: number): Observable<Contact> {
    return this.http
      .get<Contact>(this.basePath + '/v1/contacts/' + id + "?expand=expertises,full_country")
      .pipe(
        catchError(this.handleError)
      );
  }
  save(contact: any): Observable<Contact> {
    if (contact.id < 0 ) {
      return this.http
        .post<Contact>(this.basePath + '/v1/contacts?expand=expertises,full_country', contact)
        .pipe(
          catchError(this.handleError)
        );

    }
    return this.http
      .put<Contact>(this.basePath + '/v1/contacts/' + contact.id+ "?expand=expertises,full_country", contact)
      .pipe(
        catchError(this.handleError)
      );
  }
}
